module.exports = __webpack_public_path__ + "img/1678419205418-a3E3pEj7.98f60779.png";